"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _ComparisonDataDisplay = require("../../ComparisonDataDisplay.styled");
var _services = require("../../../../services");
var _brandHifiIcons = require("@vfuk/brand-hifi-icons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getEntertainmentIcons = value => {
  switch (value) {
    case 'Youtube Premium':
      return /*#__PURE__*/_react.default.createElement(_brandHifiIcons.IconYoutubePremium, {
        size: 3
      });
    case 'Spotify Premium':
      return /*#__PURE__*/_react.default.createElement(_brandHifiIcons.IconSpotify, {
        size: 3
      });
    case 'Amazon Prime':
      return /*#__PURE__*/_react.default.createElement(_brandHifiIcons.IconAmazonPrime, {
        size: 3
      });
    default:
      return value;
  }
};
const EntertainmentSpec = _ref => {
  let {
    value
  } = _ref;
  if (!value.text) return null;
  const entertainmentIcons = value.text.split(',');
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.TextDataContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    align: "center"
  }, entertainmentIcons.map((iconName, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: iconName + index
  }, getEntertainmentIcons(iconName), index !== entertainmentIcons.length - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      right: 2,
      left: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.Services.locale.localeString(`Specs.Or`)))))), value.duration && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 1,
    weight: 2
  }, _services.Services.locale.localeString(`Specs.EntertainmentSubtext`), ' ' + value.duration + ' ', _services.Services.locale.localeString(`Comparison.Months`))))));
};
var _default = EntertainmentSpec;
exports.default = _default;